/*
 * @Author: Json Chen
 * @Date: 2021-07-13 09:07:02
 * @LastEditTime: 2021-07-14 17:50:56
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PickupLocations/Components/TimeZone.tsx
 */

import { Radio } from '@/src/components/Antd';
import { Checkbox, Form } from 'antd';
import React from 'react';
import DatePickerRangePickerList from './DatePickerRangePickerList';
import PickUpTime from './PickUpTime';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../../style.module.less';

const TimeZone = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <React.Fragment>
      <div className={styles.timeZone}>
        <Form.Item name={'type'} initialValue={'All'}>
          <Radio
            radioList={[
              {
                value: 'All',
                label: getI18n('storeLogistics.pickupLocations.24hours7days'),
              },
              {
                value: 'Customize',
                label: getI18n(
                  'storeLogistics.pickupLocations.customizeavailablepickuptime',
                ),
              },
            ]}
          />
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(p, c) => p.type !== c.type}>
          {({ getFieldValue }) => {
            const type = getFieldValue('type');
            return type === 'Customize' && <PickUpTime />;
          }}
        </Form.Item>
      </div>
      <div className={styles.setDefault}>
        <Form.Item
          name={'blockService'}
          className={styles.checkbox}
          labelAlign='left'
          initialValue={false}
          valuePropName='checked'>
          <Checkbox>
            <span className={styles.checkboxText}>
              {getI18n(
                'storeLogistics.pickupLocations.blockserviceonspecificdate',
              )}
            </span>
          </Checkbox>
        </Form.Item>

        <Form.Item
          className={styles.specificDateItem}
          shouldUpdate={(p, c) => p.blockService !== c.blockService}>
          {({ getFieldValue }) => {
            const checked = getFieldValue('blockService');
            return (
              checked && (
                <Form.Item name={'blockOutDates'}>
                  <DatePickerRangePickerList />
                </Form.Item>
              )
            );
          }}
        </Form.Item>
      </div>
    </React.Fragment>
  );
};
export default TimeZone;
